import * as React from 'react';
import Box from '@mui/material/Box';
import ViewAccountTeamMembers from "./ViewAccountTeamMembers"

const HomeAccountTeamMembers = () => {

    return (
        <Box sx={{ width: '100%' }}>
            <ViewAccountTeamMembers />
        </Box>
    );
}

export default HomeAccountTeamMembers